export default "__VITE_ASSET__9a5ed021__"